
const RefrestVarients = (hasVarients,sizes,colors,setVarients)=>{
    if(hasVarients){
      var varientSendList = [];
      for (let index = 0; index < sizes.length; index++) {
        const sizee = sizes[index];
        for (let index2 = 0; index2 < colors.length; index2++) {
          const colore = colors[index2];
          varientSendList.push({
            title: sizee.name+"/"+colore.name,
            sku: "",
            price: 0,
            compareatprice:0,
            deliverytype:{name:'Select', value:'0'},
            count: 0,
            size: parseInt(sizee.value),
            color: parseInt(colore.value)
          })
        }
      }
      setVarients(varientSendList);
    }
    else{
      setVarients([]);
    }
}

export default {RefrestVarients}